var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2RainDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4 42.5A12.5 12.5 0 0157.06 55h-2v-4h1.84a8.5 8.5 0 100-17H51v-2a13 13 0 00-26 0v2h-5.9a8.5 8.5 0 100 17H37v4H19.1a12.5 12.5 0 010-25h2a17 17 0 0133.8 0h2a12.5 12.5 0 0112.5 12.5zm-23.49 2.66c0-.11-.06-.23-.08-.34 0 .11 0 .23-.08.34C45 48 41.63 50.56 41 54.4a5.669 5.669 0 00-.13 1.17v.18a5 5 0 1010-.09v-.09c0-.393-.04-.785-.12-1.17-.75-3.84-4.07-6.4-4.84-9.24zm-5.08-7.59c0-.393-.04-.785-.12-1.17-.68-3.84-4-6.35-4.8-9.24 0-.11-.06-.23-.08-.34 0 .11 0 .23-.08.34C35 30 31.63 32.56 31 36.4a5.669 5.669 0 00-.13 1.17v.18a5 5 0 1010-.09l-.04-.09z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Rain_day.8ce8cce8.svg";
export { SvgB2RainDay as ReactComponent };